<template>
    <div class="redirect_dispatcher">
        <p>Redirigiendo…</p>
    </div>
</template>

<script>
// Vista placeholder para rutas que son puros despachadores resueltos por el
// guard (p.ej. "Choose plan" / "/go-to-plan"): el beforeEach siempre redirige
// antes de que esto se monte. Existe para que la ruta no quede sin nada que
// renderizar — si alguna vez se llega sin redirección, se ve este estado en
// lugar de una pantalla en blanco.
export default {
    name: "RedirectDispatcher",
};
</script>

<style scoped>
.redirect_dispatcher {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 60vh;
    color: #6b7280;
    font-size: 14px;
}
</style>
